import type { Rect, Stroke } from "./types";

export interface Size {
  width: number;
  height: number;
}

export const rotatedSize = (width: number, height: number, degrees: number): Size => {
  const radians = (Math.abs(degrees) * Math.PI) / 180;
  const cos = Math.cos(radians);
  const sin = Math.sin(radians);
  return {
    width: Math.round(width * cos + height * sin),
    height: Math.round(width * sin + height * cos),
  };
};

export const scaleRect = (rect: Rect, scale: number): Rect => ({
  x: Math.round(rect.x * scale),
  y: Math.round(rect.y * scale),
  width: Math.max(1, Math.round(rect.width * scale)),
  height: Math.max(1, Math.round(rect.height * scale)),
});

export const clampRect = (rect: Rect, bounds: Size): Rect => {
  const x = Math.min(Math.max(0, rect.x), bounds.width - 1);
  const y = Math.min(Math.max(0, rect.y), bounds.height - 1);
  return {
    x,
    y,
    width: Math.max(1, Math.min(rect.x + rect.width, bounds.width) - x),
    height: Math.max(1, Math.min(rect.y + rect.height, bounds.height) - y),
  };
};

export const transformStrokes = (
  strokes: Stroke[],
  scale: number,
  dx: number,
  dy: number
): Stroke[] =>
  strokes.map((stroke) => ({
    mode: stroke.mode,
    radius: stroke.radius * scale,
    points: stroke.points.map((v, i) => v * scale + (i % 2 === 0 ? dx : dy)),
  }));
